import { useState, useRef } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useGeocode = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const timer = useRef(null);

  const search = (q) => {
    setQuery(q);
    setNoResults(false);
    clearTimeout(timer.current);
    if (q.length < 3) return setResults([]);
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API}/geocode?q=${encodeURIComponent(q)}`);
        const data = await res.json();
        setResults(data);
        setNoResults(data.length === 0);
      } catch {
        setResults([]);
      }
      setLoading(false);
    }, 400);
  };

  const clear = (displayName) => {
    setResults([]);
    setNoResults(false);
    if (displayName) setQuery(displayName.split(",").slice(0, 2).join(","));
  };

  return { query, results, loading, noResults, search, clear };
};
